import { render, staticRenderFns } from "./Paiement.vue?vue&type=template&id=4c05a415&scoped=true&"
import script from "./Paiement.vue?vue&type=script&lang=js&"
export * from "./Paiement.vue?vue&type=script&lang=js&"
import style0 from "./Paiement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Paiement.vue?vue&type=style&index=1&id=4c05a415&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05a415",
  null
  
)

export default component.exports